module.exports = __webpack_public_path__ + "img/directorFigure.8ff28349.png";